<template>
    <div>

        <div class="form-group ">

            <div class="d-flex justify-content-center align-items-center">
                <at :members="colaboradores" name-key="value" style="width: 100%;" v-model="comentario"
                    :deleteMatch="deleteMatch">
                    <template slot="item" slot-scope="s">
                        <span v-text="s.item.name"></span>
                    </template>
                    <div id="setComentario"  class="comment editable form-control" contenteditable></div>
                </at>

                <b-button v-if="btn_comentario" variant="outline-secondary" @click.prevent="addComentario()">
                    <i class="far fa-paper-plane"></i>
                </b-button>
            </div>
        </div>
    </div>
</template>
<script>
import At from "vue-at";
import { mapActions } from "vuex";
export default {
    props: {
        tarefa_id: { type: Number, required: true },
        reply_id: { type: Number, default: null },
        notification_id: { type: Number, default: null },
    },
    components: { At },
    data() {
        return {
            colaboradores_mencionados: [],
            colaboradores: [],
            commentsToShow: 4,
            comentario: "",
            btn_comentario: false,
        }
    },
    watch: {
        comentario(newVal, oldVal) {
            if (newVal.length >= 1) {
                this.btn_comentario = true;
            } else {
                this.btn_comentario = false;
            }

            let maskVal = "";

            const colaboradoresMarcados = this.colaboradores.filter(
                (item) => newVal.search(item.value) != -1
            );

            maskVal = newVal;

            maskVal = maskVal.replace('<i class="text-primary"></i>', "");

            maskVal = maskVal.replace('<font color="#007bff">', "");
            maskVal = maskVal.replace("</font>", "");

            colaboradoresMarcados.forEach((item) => {
                this.colaboradores_mencionados.push(item);

                maskVal = maskVal.replace(
                    "@" + item.value,
                    `<i class='text-primary' contenteditable="false">@${item.name}&nbsp;</i>`
                );
            });

            if (maskVal != newVal) {
                this.comentario = maskVal;

                this.$nextTick(() => {
                    var range, selection;
                    var contentEditableElement = document.getElementById("setComentario");
                    if (document.createRange) {
                        //Firefox, Chrome, Opera, Safari, IE 9+
                        range = document.createRange(); //Create a range (a range is a like the selection but invisible)
                        range.selectNodeContents(contentEditableElement); //Select the entire contents of the element with the range
                        range.collapse(false); //collapse the range to the end point. false means collapse to end rather than the start
                        selection = window.getSelection(); //get the selection object (allows you to change selection)
                        selection.removeAllRanges(); //remove any selections already made
                        selection.addRange(range); //make the range you have just created the visible selection
                    } else if (document.selection) {
                        //IE 8 and lower
                        range = document.body.createTextRange(); //Create a range (a range is a like the selection but invisible)
                        range.moveToElementText(contentEditableElement); //Select the entire contents of the element with the range
                        range.collapse(false); //collapse the range to the end point. false means collapse to end rather than the start
                        range.select(); //Select the range (make it the visible selection
                    }

                    contentEditableElement.focus();
                });
            }
        },
    },
    created() {
        this.getColaboradores();
    },
    mounted() {
        window.addEventListener("paste", this.paste);
    },
    methods: {
        ...mapActions("notification", ["loadNotifications"]),
        async getColaboradores() {
            const result = await this.$api.get("colaboradores");

            this.colaboradores = result.data.map((item) => {
                let arrayText = item.text.split(" ");

                arrayText = arrayText.map((element) => {
                    return (
                        element.charAt(0).toUpperCase() + element.substring(1).toLowerCase()
                    );
                });

                return {
                    id: item.value,
                    name: arrayText.join(" "),
                    value: arrayText.join(" ") + `##${item.value}##`,
                };
            });
        },
        paste(e) {
            var pastedText = undefined;

            if ($(e.target).attr("id") == "setComentario") {
                e.preventDefault();
                if (window.clipboardData && window.clipboardData.getData) {
                    // IE
                    pastedText = window.clipboardData.getData("Text");
                } else if (e.clipboardData && e.clipboardData.getData) {
                    pastedText = e.clipboardData.getData("text/plain");
                }

                this.insertTextAtCursor(pastedText);

                // const input = document.getElementById("setComentario");

                // let sel = window.getSelection();
                // sel.selectAllChildren(input);
                // sel.collapseToEnd();

                return false;
            }
        },

        deleteMatch(name, chunk) {

            console.log("deleteMatch", name, chunk+"...");

            let colaborador = this.colaboradores.find((item) => item.name == chunk.trim());

            if (colaborador) {
                console.log('colaborador', colaborador);
                let index = this.colaboradores_mencionados.findIndex(
                    (colaboradorM) => colaboradorM.id == colaborador.id
                );

                if (index != -1) {
                    this.colaboradores_mencionados.splice(index, 1);
                }

                return true;
            }

            return false;
        },

        insertTextAtCursor(text) {
            let selection = window.getSelection();
            let range = selection.getRangeAt(0);
            range.deleteContents();
            let node = document.createTextNode(text + " ");
            range.insertNode(node);

            for (let position = 0; position != text.length; position++) {
                selection.modify("move", "right", "character");
            }
        },
        async addComentario() {
            const tarefa_id = this.tarefa_id;
            const result = await this.$api.post("tarefa/addComentario", {
                action_id: this.colaboradores_mencionados.length ? 19 : 5,
                comentario: this.comentario,
                tarefa_id,
                colaboradores: this.colaboradores_mencionados,
                notification_id: this.notification_id,
                reply_id: this.reply_id,
            });

            this.comentario = "";
            this.colaboradores_mencionados = [];
            this.btn_comentario = false;

            if (this.notification_id && this.reply_id) {
                this.$bvModal.hide("replyModal");
                this.loadNotifications();
            }

            this.$emit('afterSave');
            this.$root.$emit('getComentarios');
        },
    },
    beforeDestroy() {
        window.removeEventListener("paste", this.paste);
    },
}
</script>

<style scoped>


.editable:empty::before {
    content: "Digite aqui seu comentário... e mencione alguém usando @ para incluí-lo na tarefa";
    color: #999;
}

.editable:empty:focus::before {
    content: "";
}

.comment {
    border: 1px solid #ddd;
    min-height: 85px;
    overflow: auto;
}

.comment:focus {
    color: #495057;
    background-color: #fff;
    border-color: #80bdff;
}



</style>
